export const environment = {
  serviceUrl: 'https://api-tst.vermogenstoolbouw.elaad.nl/api',
  production: false,
  keycloakUrl: 'https://iam-tst.vermogenstoolbouw.elaad.nl',
  clientId: 'otp',
  clientSecret: 'WhoXTtduCyIjdszkOvHUdj1kcQLiQgpE',
  realm: 'users',
  appInsights: { instrumentationKey: '' },
  otpConfig: {
    allowSignup: true,
    requirePassword: false,
    privacyPolicy: {
      url: '/assets/terms/privacy-policy.pdf',
      downloadFilename: 'Privacyverklaring Vermogenstool Bouw v 15 sept 25.pdf'
    },
    liabilityDisclaimer: {
      url: '/assets/terms/liability-disclaimer.pdf',
      downloadFilename: 'Aanprakelijkheidsbeperking Vermogenstool Bouw v. 3 sep 25.pdf'
    }
  }
};
